import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <div className='about-container'>
        <h1>About this app!</h1>
        <p>App to search Github users.</p>
        <br />
        <p>Auth: THAI VAN PHU</p>
        <p>Email: thaivanphu.qn95@gmail.com</p>
        <p>Mobile: 096 246 1876</p>
        <br />
        <p>Version: 1.8.2</p>
      </div>
    </Fragment>
  );
};

export default About;
